const initialState = {
  name: undefined,
  id: undefined,
  amount1: '',
  amount2: '',
  errors: [],
  ui: {
    is_submitting: false,
    show: false,
    callback_action: undefined,
  }
}

export default function (state=initialState, action){
  switch(action.type){
    case "LOAD_VERIFY_PAYMENT_SOURCE_FORM":
      return {
        ...state,
        ...action.payload
      }
    case "SET_VERIFY_PAYMENT_SOURCE_CALLBACK_ACTION":
      return {
        ...state,
        ui: {
          ...state.ui,
          callback_action: action.payload.callback_action
        }
      }
    case "UPDATE_VERIFY_PAYMENT_SOURCE_FORM_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
      }
    case "UPDATE_VERIFY_PAYMENT_SOURCE_FIELD":
      return {
        ...state,
        ...action.payload
      }
    case "BEGIN_SUBMIT_VERIFY_PAYMENT_SOURCE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true,
        }
      }
    case "FAILED_SUBMIT_VERIFY_PAYMENT_SOURCE":
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          is_submitting: false,
        }
      }
    case "RESET_VERIFY_PAYMENT_SOURCE_FORM":
      return initialState;
    default: 
      return state
  }
}